import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { CONNECTED_APPS_TABS } from '@/pages/settings/connected-apps/connected-apps-tab';
import { AdminConnectedAppsPage } from '@/pages/super-admin/mcp/AdminConnectedAppsPage';

const adminConnectedAppsSearchSchema = z.object({
	tab: z.enum(CONNECTED_APPS_TABS).default('connections'),
});

export const Route = createFileRoute('/_authenticated/super-admin/connected-apps')({
	component: AdminConnectedAppsPage,
	validateSearch: adminConnectedAppsSearchSchema,
});
